import { Stack, Text } from '@lubehub/ui-web';

import { t } from '../copy';
import type { LegalDocument } from '../legal/documents';
import { usePublicLocale } from '../locale';

export function LegalDocumentPage({ document }: { document: LegalDocument }) {
  const { locale } = usePublicLocale();
  const sections = document.sections[locale];

  return (
    <article className="legal-doc" data-testid={`legal-${document.type}`}>
      <Stack gap="lg">
        <Stack gap="xs">
          <Text as="h1" variant="display">
            {document.title[locale]}
          </Text>
          <Text variant="bodySm" tone="secondary">
            {t(locale, 'document.version', { version: document.version })}
          </Text>
          <Text variant="bodySm" tone="secondary">
            {t(locale, 'document.updated', { date: document.lastUpdated })}
          </Text>
          <Text variant="bodySm" tone="secondary">
            {t(locale, 'document.effective', { date: document.effectiveDate })}
          </Text>
        </Stack>
        {sections.map((section) => (
          <section key={section.heading}>
            <Stack gap="sm">
              <Text as="h2" variant="title">
                {section.heading}
              </Text>
              {section.paragraphs.map((paragraph) => (
                <Text key={paragraph} variant="body">
                  {paragraph}
                </Text>
              ))}
            </Stack>
          </section>
        ))}
      </Stack>
    </article>
  );
}
